import { Helmet } from 'react-helmet';

import { useEffect } from 'react';

export const PageInstall = () => {

  useEffect(() => {
    window.location.href = 'https://codesandbox.io/s/cranky-tree-bcsu8'
  }, [])

  return (
    <>
      <Helmet>
        <title>설치 코드 삽입하기</title>
      </Helmet>
      <div>
      </div>
    </>
  );
}